import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostUpdateViewAdmin = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_ADMIN_VIEW_UPDATE
            });
            window.location.replace(window.location.pathname);
        } catch (error) {
            getCatchError(error)
        }
    }
}


export {
    setPostUpdateViewAdmin as SetPostUpdateViewAdmin
} 